var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "unprintable" },
    [
      _c(
        "b-form",
        _vm._l(_vm.proteges, function(protege, index) {
          return _vm.isNewRow(index)
            ? _c("div", { key: protege.id, staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    _c("guardian-component", {
                      attrs: {
                        firstname: protege.profile.firstname,
                        lastname: protege.profile.lastname,
                        address: protege.profile.address,
                        extraAddressLine: protege.profile.extraAddressLine,
                        zipcode: protege.profile.zipcode,
                        city: protege.profile.city,
                        email: protege.profile.email,
                        mobile: protege.profile.mobile,
                        phone: protege.profile.phone,
                        website: protege.profile.website
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "gapper" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("photos.title")) +
                              "\n                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        _vm._l(
                          _vm.chunkedPhotos(
                            _vm.proteges[index].documents.photos
                          ),
                          function(photos) {
                            return _c("div", { key: photos.id }, [
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(photos, function(photo) {
                                  return _c(
                                    "div",
                                    { key: photo.id, staticClass: "col-3" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:void(0)" }
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "thumbnail",
                                            attrs: {
                                              fluid: "",
                                              src: photo.oURL,
                                              id: photo.name
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.showModal(photo.id)
                                              }
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-modal",
                                        {
                                          ref: _vm.getValidID(photo.id),
                                          refInFor: true,
                                          attrs: {
                                            id: _vm.getValidID(photo.id),
                                            title: photo.name,
                                            size: "lg",
                                            "hide-footer": true
                                          }
                                        },
                                        [
                                          _c("b-img", {
                                            attrs: {
                                              fluid: "",
                                              src: photo.oURL,
                                              id: photo.name
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "spacer" })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                })
                              )
                            ])
                          }
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "gapper" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("videos.title")) +
                              "\n                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col general-docs-item" },
                        _vm._l(_vm.proteges[index].documents.videos, function(
                          video
                        ) {
                          return _c("div", { key: video.id }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    _vm.downloadVideo(
                                      _vm.proteges[index].profile.id,
                                      video.id,
                                      video.name,
                                      index
                                    )
                                  }
                                }
                              },
                              [
                                _c("icon", { attrs: { name: "film" } }),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(video.name) +
                                    "\n                            "
                                )
                              ],
                              1
                            )
                          ])
                        })
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "row video-player-container",
                        class: {
                          "player-is-not-shown": _vm.videoNotLoaded(index)
                        }
                      },
                      [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "embed-responsive embed-responsive-1by1"
                            },
                            [
                              _c(
                                "video",
                                {
                                  attrs: {
                                    controls: "",
                                    id: "video-player" + index,
                                    muted: "true"
                                  },
                                  domProps: { muted: true }
                                },
                                [
                                  _c("source", { attrs: { src: "" } }),
                                  _vm._v(
                                    "\n                                Your browser does not support the video tag.\n                            "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "gapper" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("documents.generalDocs.title")) +
                              "\n                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col general-docs-item" },
                        _vm._l(
                          _vm.proteges[index].documents.generalDocs,
                          function(document) {
                            return _c("div", { key: document.id }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "javascript:void(0)" },
                                  on: {
                                    click: function($event) {
                                      _vm.download(
                                        _vm.proteges[index].profile.id,
                                        document.id,
                                        document.name
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("icon", { attrs: { name: "file-o" } }),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(document.name) +
                                      "\n                            "
                                  )
                                ],
                                1
                              )
                            ])
                          }
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "gapper" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("speeches.allInfo.title")) +
                              "\n                        "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col download-link" }, [
                        protege.speeches.deathNoticeFile.url != null
                          ? _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    _vm.downloadSpeech(
                                      protege.profile.id,
                                      _vm.deathNoticeType,
                                      protege.speeches.deathNoticeFile.name
                                    )
                                  }
                                }
                              },
                              [
                                _c("icon", { attrs: { name: "file-o" } }),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t("speeches.documents.obituaryText")
                                    ) +
                                    "\n                        "
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col download-link" }, [
                        protege.speeches.burialSpeechFile.url != null
                          ? _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    _vm.downloadSpeech(
                                      protege.profile.id,
                                      _vm.burialSpeechType,
                                      protege.speeches.burialSpeechFile.name
                                    )
                                  }
                                }
                              },
                              [
                                _c("icon", { attrs: { name: "file-o" } }),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t(
                                        "speeches.documents.funeralSpeechText"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col download-link" }, [
                        protege.speeches.ceremonySpeechFile.url != null
                          ? _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    _vm.downloadSpeech(
                                      protege.profile.id,
                                      _vm.ceremonySpeechType,
                                      protege.speeches.ceremonySpeechFile.name
                                    )
                                  }
                                }
                              },
                              [
                                _c("icon", { attrs: { name: "file-o" } }),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t(
                                        "speeches.documents.partySpeechText"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col download-link" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row delete-and-print-section" }, [
                      _c("div", { staticClass: "col delete-protege-link" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                _vm.deleteProtege(protege.profile.id)
                              }
                            }
                          },
                          [
                            _c("icon", { attrs: { name: "trash-o" } }),
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("proteges.deleteLink")) +
                                "\n                        "
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col print-link" },
                        [
                          _c("protege-all-info-component", {
                            attrs: { protege: protege }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-sm-6" },
                  [
                    index < _vm.proteges.length - 1
                      ? _c("guardian-component", {
                          attrs: {
                            firstname:
                              _vm.proteges[index + 1].profile.firstname,
                            lastname: _vm.proteges[index + 1].profile.lastname,
                            address: _vm.proteges[index + 1].profile.address,
                            extraAddressLine:
                              _vm.proteges[index + 1].profile.extraAddressLine,
                            zipcode: _vm.proteges[index + 1].profile.zipcode,
                            city: _vm.proteges[index + 1].profile.city,
                            email: _vm.proteges[index + 1].profile.email,
                            mobile: _vm.proteges[index + 1].profile.mobile,
                            phone: _vm.proteges[index + 1].profile.phone,
                            website: _vm.proteges[index + 1].profile.website
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("div", { staticClass: "gapper" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("photos.title")) +
                                  "\n                        "
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col" },
                            _vm._l(
                              _vm.chunkedPhotos(
                                _vm.proteges[index + 1].documents.photos
                              ),
                              function(photos) {
                                return _c("div", { key: photos.id }, [
                                  _c(
                                    "div",
                                    { staticClass: "row" },
                                    _vm._l(photos, function(photo) {
                                      return _c(
                                        "div",
                                        { key: photo.id, staticClass: "col-3" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0)"
                                              }
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "thumbnail",
                                                attrs: {
                                                  fluid: "",
                                                  src: photo.oURL,
                                                  id: photo.name
                                                },
                                                on: {
                                                  click: function($event) {
                                                    _vm.showModal(photo.id)
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-modal",
                                            {
                                              ref: _vm.getValidID(photo.id),
                                              refInFor: true,
                                              attrs: {
                                                id: _vm.getValidID(photo.id),
                                                title: photo.name,
                                                size: "lg",
                                                "hide-footer": true
                                              }
                                            },
                                            [
                                              _c("b-img", {
                                                attrs: {
                                                  fluid: "",
                                                  src: photo.oURL,
                                                  id: photo.name
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "spacer"
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    })
                                  )
                                ])
                              }
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("div", { staticClass: "gapper" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("videos.title")) +
                                  "\n                        "
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col general-docs-item" },
                            _vm._l(
                              _vm.proteges[index + 1].documents.videos,
                              function(video) {
                                return _c("div", { key: video.id }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function($event) {
                                          _vm.downloadVideo(
                                            _vm.proteges[index + 1].profile.id,
                                            video.id,
                                            video.name,
                                            index + 1
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("icon", { attrs: { name: "film" } }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(video.name) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  )
                                ])
                              }
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c(
                          "div",
                          {
                            staticClass: "row video-player-container",
                            class: {
                              "player-is-not-shown": _vm.videoNotLoaded(
                                index + 1
                              )
                            }
                          },
                          [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "embed-responsive embed-responsive-1by1"
                                },
                                [
                                  _c(
                                    "video",
                                    {
                                      attrs: {
                                        controls: "",
                                        id: "video-player" + (index + 1),
                                        muted: "true"
                                      },
                                      domProps: { muted: true }
                                    },
                                    [
                                      _c("source", { attrs: { src: "" } }),
                                      _vm._v(
                                        "\n                                Your browser does not support the video tag.\n                            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("div", { staticClass: "gapper" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$t("documents.generalDocs.title")
                                  ) +
                                  "\n                        "
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col general-docs-item" },
                            _vm._l(
                              _vm.proteges[index + 1].documents.generalDocs,
                              function(document) {
                                return _c("div", { key: document.id }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function($event) {
                                          _vm.download(
                                            _vm.proteges[index + 1].profile.id,
                                            document.id,
                                            document.name
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("icon", { attrs: { name: "file-o" } }),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(document.name) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  )
                                ])
                              }
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("div", { staticClass: "gapper" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("speeches.allInfo.title")) +
                                  "\n                        "
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col download-link" }, [
                            _vm.proteges[index + 1].speeches.deathNoticeFile
                              .url != null
                              ? _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        _vm.downloadSpeech(
                                          _vm.proteges[index + 1].profile.id,
                                          _vm.deathNoticeType,
                                          _vm.proteges[index + 1].speeches
                                            .deathNoticeFile.name
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("icon", { attrs: { name: "file-o" } }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t(
                                            "speeches.documents.obituaryText"
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col download-link" }, [
                            _vm.proteges[index + 1].speeches.burialSpeechFile
                              .url != null
                              ? _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        _vm.downloadSpeech(
                                          _vm.proteges[index + 1].profile.id,
                                          _vm.burialSpeechType,
                                          _vm.proteges[index + 1].speeches
                                            .burialSpeechFile.name
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("icon", { attrs: { name: "file-o" } }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t(
                                            "speeches.documents.funeralSpeechText"
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col download-link" }, [
                            _vm.proteges[index + 1].speeches.ceremonySpeechFile
                              .url != null
                              ? _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        _vm.downloadSpeech(
                                          _vm.proteges[index + 1].profile.id,
                                          _vm.ceremonySpeechType,
                                          _vm.proteges[index + 1].speeches
                                            .ceremonySpeechFile.name
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("icon", { attrs: { name: "file-o" } }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t(
                                            "speeches.documents.partySpeechText"
                                          )
                                        ) +
                                        "\n                        "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col download-link" })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    index < _vm.proteges.length - 1
                      ? _c(
                          "div",
                          { staticClass: "row delete-and-print-section" },
                          [
                            _c(
                              "div",
                              { staticClass: "col delete-protege-link" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        _vm.deleteProtege(
                                          _vm.proteges[index + 1].profile.id
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("icon", { attrs: { name: "trash-o" } }),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$t("proteges.deleteLink")) +
                                        "\n                        "
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col print-link" },
                              [
                                _c("protege-all-info-component", {
                                  attrs: { protege: _vm.proteges[index + 1] }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            : _vm._e()
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66764ef8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66764ef8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guardian/ProtegesComponent.vue
// module id = null
// module chunks = 